function newsReducer(state, action) {
    switch (action.type) {
        case "GET_NEWS":
            return action.news
        case "ADD_NOTE":
            return [
                ...state,
                {
                    title: action.title,
                    body: action.description,
                    url: action.url,
                },
            ] //spreads out existing news objects and adds a new news object
        case "REMOVE_NOTE":
            return state.filter((news) => news.title !== action.title)
        default:
            return state
    }
}

export { newsReducer as default } //exporting the reducer function as default
